import MaxWidthWrapper from 'components/wrappers/MaxWidthWrapper';
import PropTypes from 'prop-types';
import React from 'react';
import TextBlock from 'libs/wordpress/content/cmsBlocks/TextBlock';
import { bleedMargins } from 'config/theme/contentMargins';
import colors from 'config/theme/colors';
import styled from 'libs/styled';

const Section = styled('section')``;

const TextLayout = ({ last = false, ...rest }) => (
    <Section
        mx={bleedMargins}
        borderBottom={!last && `1px solid ${colors.blackOpacityHigh}`}
        mb={!last && ['16px', null, '24px']}
        pb="40px"
    >
        <MaxWidthWrapper includeContentMargins>
            <TextBlock columnBase={[12, null, null, null, 8]} columnSizes={[12, null, 8, null, 6]} {...rest} />
        </MaxWidthWrapper>
    </Section>
);

TextLayout.propTypes = {
    last: PropTypes.bool,
};

export default TextLayout;
